module.exports = __webpack_public_path__ + "assets/path-5-0aa009edd943057da3713ded54bbe2aa.svg";